import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  employees: [],
  roles: [],
  employeeById: [],
  totalCount: 0,
};

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        employees: [],
        loading: action.payload,
      };
    case TYPE.GET_ALL_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: action.payload,
        employees: action.payload.data,
        totalCount: action.payload.total_count,
      };
    case TYPE.GET_ALL_EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        employees: [],
        totalCount: 0,
      };
    case TYPE.CREATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: action.payload,
        employees: [...state.employees, action.payload],
      };
    case TYPE.CREATE_EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        employees: [],
      };
    case TYPE.GET_EMPLOYEE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        roles: action.payload,
      };
    case TYPE.GET_EMPLOYEE_ROLE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        roles: [],
      };
    case TYPE.GET_EMPLOYEE_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        employeeById: action.payload,
      };
    case TYPE.GET_EMPLOYEE_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        employeeById: [],
      };
    case TYPE.UPDATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: action.payload,
      };
    case TYPE.UPDATE_EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      };
    case TYPE.ACTIVATE_DEACTIVATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: action.payload,
      };
    case TYPE.ACTIVATE_DEACTIVATE_EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      };
    case TYPE.DELETE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: action.payload,
      };
    case TYPE.DELETE_EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      };
    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default employeeReducer;
